import { useRootLoadersStore } from "./root-loaders.store";

export const useRootLoaders = () => {
  const rootLoaders = useRootLoadersStore((state) => state.rootLoaders);

  const someRootPending = useRootLoadersStore((state) =>
    Object.values(state.rootLoaders).some(
      (rootLoader) => (rootLoader?.pendingCounter || 0) > 0
    )
  );

  return { rootLoaders, someRootPending };
};
